import { DefaultI18nValues } from './types';

export const defaultI18nEn: DefaultI18nValues = {
	'general.back': 'Back',
	'general.genericError.title': 'We apologize but we were unable to receive your order. Please try again later.',
};
